import { Model, QiraMessage, Source, ThreadWithoutMessagesDto, Vehicle, VehicleIdentification } from 'api3';

/**
 * Copied from ../question-answering-2/src/data-provider/providers.ts
 * Fits to the type `Source.provider` in api3
 */
export enum QiraDataProvider {
  HaynesPro = 'haynespro',
  HGS = 'hgs',
  Mercedes = 'mercedes',
  QiraDB = 'qiradb',
  Seat = 'seat',
  Audi = 'audi',
  Skoda = 'skoda',
  Static = 'static',
  Tesla = 'tesla',
  Varta = 'varta',
  Volkswagen = 'volkswagen',
}

/**
 * Copied from ../question-answering-2/src/rmi/rmi.dto.ts
 * Fits to the type `Source.subject` in api3
 */
export enum QiraSubject {
  Adjustments = 'Adjustments',
  Battery = 'Battery',
  Bulletins = 'Bulletins',
  ControlUnitLocations = 'ControlUnitLocations',
  Default = 'Default',
  EngineLocations = 'EngineLocations',
  EOBDLocations = 'EOBDLocations',
  ErrorCode = 'ErrorCode',
  FuseBoxes = 'FuseBoxes',
  FuseLocations = 'FuseLocations',
  GroundingPointLocations = 'GroundingPointLocations',
  HVACLocations = 'HVACLocations',
  Lubricants = 'Lubricants',
  MaintenanceForms = 'MaintenanceForms',
  MaintenancePeriods = 'MaintenancePeriods',
  MaintenanceProcesses = 'MaintenanceProcesses',
  MaintenanceServiceResets = 'MaintenanceServiceResets',
  Recalls = 'Recalls',
  RepairManuals = 'RepairManuals',
  RepairTimes = 'RepairTimes',
  SmartCases = 'SmartCases',
  TechnicalDrawings = 'TechnicalDrawings',
  WarningLights = 'WarningLights',
  WiringDiagrams = 'WiringDiagrams',
}

export type ChatTab = ThreadWithoutMessagesDto & {
  vehicle: Vehicle | undefined;
  messages: QiraMessage[];
  isPolling?: boolean;
  isPollingSince?: Date;
  isDeleted?: boolean;
};

export type SendMessage = {
  threadId: string;
  text: string;
};

export type GetThreadMessagesOptions = {
  threadId: string;
  filters?: {
    created_after: string;
  };
};

export type SourceDto = Source & {
  title?: string;
  url?: string;
};

export type DisplayVehicle = Vehicle & {
  displayString?: string;
  vehicleIdentification?: VehicleIdentification;
};

export type DisplayModel = Model & {
  displayString?: string;
};

export type SourceUrl = {
  path: string;
  params?: Record<string, string>;
};
